import React from "react";

import { Icon, IconProps } from "../";

export const AccountIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M100,52 C102.21,52 104,50.21 104,48 C104,45.79 102.21,44 100,44 C97.79,44 96,45.79 96,48 C96,50.21 97.79,52 100,52 Z M100,54 C97.33,54 92,55.34 92,58 L92,59 C92,59.55 92.45,60 93,60 L107,60 C107.55,60 108,59.55 108,59 L108,58 C108,55.34 102.67,54 100,54 Z"
        transform="translate(-88 -40)"
      />
    </Icon>
  );
};
